// extracted by mini-css-extract-plugin
export default {"main":"NLeftPart_main__86lSr","title":"NLeftPart_title__4rNLy","left":"NLeftPart_left__pFUBz","right":"NLeftPart_right__Gi5+u","info":"NLeftPart_info__uGXq3"};